/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown>, price: NonNullable<unknown> }} Cost_Calc_Storage_LineInputs */



/**
* | output |
* | --- |
* | "{label} storage: €{price}/mo" |
*
* @param {Cost_Calc_Storage_LineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_calc_storage_line = /** @type {((inputs: Cost_Calc_Storage_LineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Calc_Storage_LineInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.label} Speicher: €${i?.price}/Mo.`)
	return /** @type {LocalizedString} */ (`${i?.label} storage: €${i?.price}/mo`)
});